import { vacancyKeys } from "../config";

export const formatData = (tabKey, values, updatedValues, userRole) => {
  values =
    values?.length > 0
      ? values?.filter(function (entry) {
          return entry === "" ? entry.trim() !== "" : entry;
        })
      : [];

  if (values && values.length > 0) {
    values = values.filter(function (element) {
      return element !== undefined;
    });
    // console.log("tabKey in formatData", tabKey)
    switch (tabKey) {
      case "help":
        return getTempValues(tabKey, values, updatedValues, userRole);
      //   case TAB_KEYS.logo:
      //     return getLogoTempValues(tabKey, values, updatedValues);
      default:
        return {};
    }
  } else {
    return {};
  }
};

const getSortedData = (modifiedValues, updatedDataIds, tabKey) => {
  var items = {};
  console.log("In getSortedData -----------------------------");
  console.log("modifiedVal", modifiedValues);
  console.log("updatedVal", updatedDataIds);
  // console.log("tabKey", tabKey);
  if (modifiedValues && modifiedValues.length > 0) {
    const freshItems =
      modifiedValues.filter((d) => (vacancyKeys.includes(tabKey) ? d.id : d.id))
        .length > 0
        ? []
        : modifiedValues;
    if (freshItems.length > 0) {
      items["newData"] = vacancyKeys.includes(tabKey)
        ? getVacancyFormData(freshItems)
        : getFormData(freshItems, tabKey);
    } else {
      const modify = modifiedValues.filter(
        (d) => !(vacancyKeys.includes(tabKey) ? d.id : d.id)
      );
      if (modify && modify.length > 0) {
        items["extraData"] = vacancyKeys.includes(tabKey)
          ? getVacancyFormData(modify)
          : getFormData(modify, tabKey);
      }
      const tempD = [];
      modifiedValues.forEach((d, i) => {
        if (
          updatedDataIds &&
          updatedDataIds.includes(i) &&
          (vacancyKeys.includes(tabKey) ? d.id : d.id)
        ) {
          tempD.push(d);
        }
      });
      if (tempD.length > 0) {
        items["editedData"] = getFormData(tempD, tabKey);
      }
    }
  }
  console.log("items in sorted", items);
  return items; 
};

export const getFormData = (data, tabKey) => {
  console.log("getFormData-----------------------------");
  console.log("data", data);
  var formData = new FormData();
  const modifiedData = data.map((d) => {
    // console.log('data', d);
    // console.log('data', d.media);
    // console.log('data', d.file);
    if (d.file) {
      // console.log('came');
      formData.append("medias", d.file);
      delete d.file;
    }
    // if (d.mediaLink) {
    //   d.media = d.mediaLink;
    //   delete d.mediaLink;
    // }
    return d;
  });
  console.log("modifiedData to be blob", modifiedData);
  const json = JSON.stringify(modifiedData);
  const blob = new Blob([json], {
    type: "application/json",
  });

  formData.append("helpSectionInputs", blob);

  //   if (tabKey === "help") {
  //     formData.append("helpSectionInputs", blob);
  //   } else {
  //     formData.append("helpSectionInputs", blob);
  //   }

  return formData;
};

const getVacancyFormData = (data) => {
  var formData = new FormData();
  const modifiedData = data.map((d) => {
    if (d.file) {
      // console.log('came');
      formData.append("files", d.file);
      delete d.file;
    }
    return d;
  });
  const json = JSON.stringify(modifiedData);
  const blob = new Blob([json], {
    type: "application/json",
  });

  formData.append("vacancyDtoList", blob);

  return formData;
};

const getTempValues = (tabKey, values, updatedValues, userRole) => {
  // console.log('updatedValues', updatedValues);
  console.log("getTempValues", values);
  const updatedDataIds = updatedValues[tabKey];

  if (values && values.length > 0) {
    const modifiedValues = values.map((d) => {
      if (d) {
        var temp = {};
        if (d && d.id) {
          temp.id = d.id;
        }
        temp.title = d.title;
        temp.description = d.description;
        temp.webLink = d.webLink;
        temp.assetTypeEnum = d.assetTypeEnum;
        temp.assetTypeName = d?.assetTypeName;
        // temp.type = tabKey;
        temp.userRole = userRole;
        if (d && d.blob) {
          temp["file"] = d.blob;
        }
        if (d && d.mediaLink) {
          console.log("in medialink", d.mediaLink)
          const mediaEx = d.mediaLink;
          if (mediaEx.mediaType === "IMAGE" && mediaEx.mediaProperty) {
          console.log("in medialink image")
            temp.mediaLink = {
              mediaProperty: mediaEx.mediaProperty,
              mediaType: "IMAGE",
            };
          } else if (mediaEx.mediaType === "IMAGE" && mediaEx.url) {
            console.log("in medialink image")
              // temp.mediaLink = {
              //   mediaProperty: mediaEx.url,
              //   mediaType: "IMAGE",
              // };
            } else if (mediaEx.mediaType === "SOCIAL_MEDIA" && mediaEx.url) {
          console.log("in medialink yt")
            temp.mediaLink = {
              mediaType: "SOCIAL_MEDIA",
              url: mediaEx.url,
            };
          } else if (mediaEx.mediaType === "VIMEO_MEDIA" && mediaEx.url) {
          console.log("in medialink vm")
            temp.mediaLink = {
              mediaType: "VIMEO_MEDIA",
              url: mediaEx.url,
            };
          }   else if (mediaEx.mediaType === "SYNTHESIA_MEDIA" && mediaEx.url) {
            temp.mediaLink = {
              mediaType: "SYNTHESIA_MEDIA",
              url: mediaEx.url,
            };
          }
        }
        console.log("temp", temp);
        return temp;
      }
      return d;
    });
    console.log("modifiedValues", modifiedValues);

    return getSortedData(modifiedValues, updatedDataIds, tabKey);
  } else {
    return {};
  }
};
